module.exports = __webpack_public_path__ + "img/label.3db6bfd0.png";